module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"compareTypeDefault":"Porównaj z poprzednim zakresem","compareTypeYear":"Porównaj do ubiegłego roku"}}')
  delete Component.options._Ctor
}
